import { lazy } from 'react';
import ProtectedRoute from '@/components/ProtectedRoute';

const TitulosIndex = lazy(() => import('./Index'));
const TitulosDashboard = lazy(() => import('./Dashboard'));
const TituloForm = lazy(() => import('./Form'));
const AprovacaoPrazo = lazy(() => import('./AprovacaoPrazo'));

export const titulosRoutes = [
    {
        path: '/titulos',
        element: (
            <ProtectedRoute permission="titulos.view">
                <TitulosIndex />
            </ProtectedRoute>
        ),
    },
    {
        path: '/titulos/dashboard',
        element: (
            <ProtectedRoute permission="titulos.view">
                <TitulosDashboard />
            </ProtectedRoute>
        ),
    },
    {
        path: '/titulos/novo',
        element: (
            <ProtectedRoute permission="titulos.create">
                <TituloForm />
            </ProtectedRoute>
        ),
    },
    {
        path: '/titulos/aprovacao-prazo',
        element: (
            <ProtectedRoute permission="titulos.aprovar.prazo">
                <AprovacaoPrazo />
            </ProtectedRoute>
        ),
    },
    {
        path: '/titulos/:id',
        element: (
            <ProtectedRoute anyOf={['titulos.view', 'titulos.aprovar.prazo']}>
                <TituloForm />
            </ProtectedRoute>
        ),
    },
];
